/* External */
import { v4 as uuid } from 'uuid';

export function generateRequestActionCreator(actionCreator) {
  return (...args) => {
    const action = actionCreator(...args);
    action.requestId = uuid();
    return action;
  };
}

export function generateEntityActionCreators(entitityActionTypes) {
  return {
    add(entities) {
      return {
        type: entitityActionTypes.ADD,
        payload: entities,
      };
    },
    clean() {
      return {
        type: entitityActionTypes.CLEAN,
      };
    },
  };
}
